import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import SearchForm from "~/Components/Forms/Search/SearchForm";
import Tile from "~/Components/Tile";
import Message from "~/Components/Message";
import Section from "~/Components/Section";
import RecentPopularTagsContainer from "~/Containers/RecentPopularTagsContainer";
import Spinner from "react-bootstrap/Spinner";

import "./SearchPage.less";

export const Wrapper = styled.section`
  margin: 20px 0 40px;
  text-align: center;
  .recentFileUnders {
    margin-top: 60px;
  }
`;

const SearchPage = () => {
  const [failure, setFailure] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [terms, setTerms] = useState();
  const [loading, setLoading] = useState(false);

  const onFailure = () => {
    setFailure(true);
  };
  const onSubmit = () => {
    setHasSearched(true);
    setLoading(true);
  };

  const onSave = (data) => {
    setLoading(false);
    // console.log("searchResults !!! data:", data);
    // @TODO load more results, ok for now
    setSearchResults(data.posts);
    setTerms(data.search_terms);
  };

  return (
    <div className="about-page-component">
      <Helmet>
        <title>____ of the Day | Dream Chimney</title>
        <link rel="canonical" href={`https://www.dreamchimney.com/oftheday/search`} />
      </Helmet>
      <div className="pageTitle">Search</div>
      <div className="aboutPageWrapper">
        <Message>
          <div style={{ marginBottom: "20px" }}>Enter a keyword below to find previous posts</div>
          <SearchForm onFailure={onFailure} onSubmit={onSubmit} onComplete={onSave} />
        </Message>
      </div>

      <div>
        <Wrapper>
          {!hasSearched && (
            <Section className="recentFileUnders" title="Recent Popular File Unders:">
              <RecentPopularTagsContainer
                render={({ tags, loading, failure }) => {
                  return (
                    <span className="fileUnderTag tagLg">
                      {tags.map((t) => (
                        <Link to={`/tag/${t.tag_slug}`}>{t.tag}</Link>
                      ))}
                    </span>
                  );
                }}
              ></RecentPopularTagsContainer>
            </Section>
          )}
          {loading && (
            <div>
              <Spinner animation="border" size="sm" /> Loading
            </div>
          )}
          {failure && <h4>Unknown Error =(</h4>}
          {!loading && searchResults.length !== 0 && <h4>Results for "{terms}"</h4>}
          {!loading && hasSearched && searchResults.length === 0 && <h5>Sadly nothing was found. Please try again.</h5>}
        </Wrapper>
        <Row noGutters className="minimalGutter">
          {!loading &&
            searchResults &&
            searchResults.map((item) => (
              <Col xl={4} lg={6} xs={12} key={item.id}>
                <Tile archive otd={item} />
              </Col>
            ))}
        </Row>
      </div>
    </div>
  );
};

export default SearchPage;
